import { observer } from 'mobx-react';
// import { action } from 'mobx';
import React from 'react';
import { Button, Form, Icon, Input } from 'semantic-ui-react';

import Modal from '../../shared/Modal/';
import customFetch from '../../../utils/customFetch';
import CaseManagersStore from './CaseManagersStore';

const reasons = [
  { key: 'duplicate', text: 'Duplicate CM', value: 'Duplicate CM' },
  { key: 'incorectInfo', text: 'Incorrect information', value: 'Incorrect information' },
  { key: 'already', text: 'Already left the company', value: 'Already left the company' },
  { key: 'notworkinpersonalinjury', text: 'Does not work in personal injury', value: 'Does not work in personal injury' },
  { key: 'other', text: 'Other', value: 'Other' },
];

@observer
class ModalDisableUser extends React.Component {
  constructor(props) {
    super(props);
    console.log(this.props.modalParams);
    this.state = {
      Id: this.props.modalParams.modalParams.Id,
      record: this.props.modalParams.modalParams.Record,
      Reason: 'Duplicate CM',
      OtherDetail: '',
      errorReason: 'This field is required.',
    };
  }
  onCancel = () => {
    this.props.onCancel();
  };

  handleDisableUser = async () => {
    const { Id, Reason, OtherDetail } = this.state;
    CaseManagersStore.setFieldsValue({ loading: true });
    if (Reason === 'Other' && !OtherDetail) return;
    try {
      await customFetch('/Staff/Authorize', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({ Id: Id, Reason: Reason, OtherDetail: OtherDetail }),
      });

      await CaseManagersStore.fetchCase({}, true);
    } finally {
      CaseManagersStore.setFieldsValue({ loading: false });
      this.props.onCancel();
    }
  };

  handleOnChangeDropDown = (e, { value }) => {
    this.setState({ ...this.state, Reason: value });
  };

  handleOnChangOtherDetail = (e, { value }) => {
    if (value) {
      this.setState({ ...this.state, OtherDetail: value });
      this.setState({ errorReason: '' });
    } else {
      this.setState({ ...this.state, OtherDetail: value });
      this.setState({
        errorReason: `This field is required.`,
      });
    }
  };

  render() {
    const { open } = CaseManagersStore;
    const { record, Reason, OtherDetail } = this.state;
    console.log(record);
    return (
      <React.Fragment>
        <Modal
          visible={open}
          width={600}
          onCancel={this.props.onCancel}
          footer={
            <React.Fragment>
              <Button color="blue" onClick={this.handleDisableUser}>
                <Icon name="save" /> Save
              </Button>
              <Button color="red" onClick={this.onCancel}>
                <Icon name="close" /> Close
              </Button>
            </React.Fragment>
          }
          title="Disable Case Manager"
        >
          <Form>
            <div style={{ minHeight: '250px' }}>
              <div>
                Please provide reason for disabling case manager {record?.FirstName} {record?.LastName}
              </div>
              <Form.Dropdown
                required
                fluid
                label="Reason"
                placeholder="Reason"
                id="form-input-first-name"
                search
                selection
                value={Reason}
                onChange={this.handleOnChangeDropDown}
                options={reasons}
              />
              {Reason === 'Other' && (
                <Form.Field
                  required
                  control={Input}
                  label="Reason"
                  fluid
                  error={this.state.errorReason ? { content: this.state.errorReason } : null}
                  placeholder="Reason"
                  value={OtherDetail}
                  onChange={this.handleOnChangOtherDetail}
                />
              )}
            </div>
          </Form>
        </Modal>
      </React.Fragment>
    );
  }
}

export default ModalDisableUser;
